import React, { useEffect } from "react";
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { FormControl, InputLabel, MenuItem, Select as MuiSelect, FormHelperText } from '@mui/material';

// const useStyles = makeStyles((theme) => ({
//   root: {
//     margin: theme.spacing(1),
//     // width: '90%',
//     display: "flex",
//     backgroundColor : "white",
//     "& .MuiOutlinedInput-input": {
//       padding: theme.spacing(1),
//       margin: theme.spacing(0.8),
//       color: "#424448",
//       fontWeight: 700,
//       letterSpacing: 2,
//     },
//     "& .MuiInputLabel-formControl": {
//       top: -9,
//       left: 45,
//     },
//     "& .MuiInputLabel-shrink": {
//       top: -6,
//       left: 0,
//       fontSize: "1rem !important",
//       fontStyle: "italic",
//       color: "#899098",
//     },
//     "& #autocompletemultiselect": {
//       margin: 0,
//       padding: "4px 4px 4px 6px",
//     },
//   },
// }));

const MultiSelect = (props) => {
  // const classes = useStyles();
  const {
    label,
    name,
    // addEnabled = false,
    value,
    isDuplicateList = false,
    placeholder,
    disabled = false,
    required = false,
    multiple = true,
    error = null,
    className
  } = props;

  let items = [...props.items]; //Avoid if duplicate records
  if (items && isDuplicateList && items.length > 0) {
    items = items.filter(
      (v, i, a) => a.findIndex((v2) => v2.name === v.name) === i
    );
  }

  const getSelectedValue = () => {
    if (value) {
      if (typeof value === "string" || typeof value === "number") {
        const temp = items && items.find((e) => e.sid && e.sid == value); //Array with object
        if (temp) {
          return temp["name"];
        } else {
          return value;
        }
      } else if (Array.isArray(value)) {
        const temp =
          items && items.filter((e) => e.sid && value.includes(e.sid)); //Array with object
        if (temp && temp.length > 0) {
          return temp;
        } else {
          // return value;
          return [];
        }
      }
    } else {
      return "";
    }
  };

  return (
    <FormControl
      // classes={{ root: classes.root }}
      // className={className}
      className={className}
      required={required}
      {...(error && { error: true, helperText: error })}
    >
      <Autocomplete
        value={getSelectedValue()}
        multiple={multiple}
        limitTags={1}
        className="autocompleteSingle"
        disableCloseOnSelect
        onChange={(event, newValue) => {
          if (typeof newValue === "string") {
            props.onChange({ target: { name, value: newValue } });
          } else if (Array.isArray(newValue)) {
            props.onChange({
              target: {
                name,
                value: newValue.map(function (item) {
                  return item["sid"];
                }),
              },
            });
          } else if (newValue && newValue.inputValue) {
            // Create a new value from the user input
            props.onChange({ target: { name, value: newValue.inputValue } });
          } else {
            if (newValue) {
              props.onChange({ target: { name, value: newValue.sid } });
            } else {
              props.onChange({ target: { name, value: "" } });
            }
          }
        }}
        //selectOnFocus
        //clearOnBlur
        //handleHomeEndKeys
        id="autocompletemultiselect"
        options={items}
        required={required}
        disabled={disabled}
        name={name}
        getOptionLabel={(option) => {
          // Value selected with enter, right from the input
          if (typeof option === "string") {
            return option;
          }
          // Add "xxx" option created dynamically
          if (option.inputValue) {
            return option.inputValue;
          }
          // Regular option
          return option.name;
        }}
        renderOption={(props, option) => (
          <li key={option.sid} {...props}>
            {option.name}
          </li>
        )}
        //freeSolo
        renderInput={(params) => (
          <TextField
            {...params}
            label={label}
            error={error}
            placeholder={placeholder}
            className={className}
          />
        )}
      />
      {error && <FormHelperText className="required">{error}</FormHelperText>}
    </FormControl>
  );
};

export default MultiSelect;

// import React from 'react';
// import { FormControl, InputLabel, MenuItem, Select as MuiSelect, makeStyles, FormHelperText } from '@material-ui/core';

// const useStyles = makeStyles(theme => ({
//     root: {
//         margin: theme.spacing(1),
//         // width: '90%',
//         display: 'flex',
//         '& .MuiOutlinedInput-input': {
//             padding: theme.spacing(0.8),
//             margin: theme.spacing(0.8),
//         },
//         '& .MuiInputLabel-formControl': {
//             top: -9,
//             left: 45,
//         },
//         '& .MuiInputLabel-shrink': {
//             top: -6,
//             left: 17,
//         }
//     }
// }));

// const MultiSelect = (props) => {
//     const classes = useStyles();
//     const { name, label, value, onChange, required=false, items, error=null, ...others } = props;

//     return <FormControl classes={{root: classes.root}} required={required} {...(error && { error: true, helperText: error})}>
//         <InputLabel className={others.className}>{label}</InputLabel>
//         <MuiSelect
//             label={label}
//             name={name}
//             value={value}
//             onChange={onChange}
//             required={required}
//             variant={'outlined'}
//             multiple={true}
//             {...others}
//         >
//             <MenuItem key={0} value={0}>None</MenuItem>
//             {
//                 items.map(o => <MenuItem key={o.id} value={o.id}>{o.title}</MenuItem>)
//             }
//         </MuiSelect>
//         {error && <FormHelperText>{error}</FormHelperText>}
//     </FormControl>;
// }

// export default MultiSelect;
